import { auth_api_uri } from '../config/Auth0'

export default async function logout({ returnTo } = {}) {
  try {
    await fetch(`${auth_api_uri}/api/auth/logout`, {
      method: 'POST',
      headers: { 'X-Client': 'web' },
      credentials: 'include'
    })
  } catch (error) {
    console.error('Server logout failed:', error)
  }
  localStorage.removeItem('credentials')
  localStorage.removeItem('user')
  localStorage.removeItem('expiration')
  localStorage.removeItem('appState')
  if (returnTo) {
    window.location.href = returnTo
  }
}
